import config from '../config.json'

const baseUrl = () => {

  switch(config.partner) {
    case 'lv':
      return 'https://europe-west1-call-legal-expert.cloudfunctions.net'
      // return 'http://localhost:5001/call-legal-expert/europe-west1' 
    case 'axa':
      return 'https://europe-west1-axa-legal-expert.cloudfunctions.net'
      // return 'http://localhost:5001/axa-legal-expert/europe-west1'
    default:
      return ''
  }
}

export {
  baseUrl
}